import * as tslib_1 from "tslib";
import AmCharts from "../AmCharts";
import cx from 'classnames';
import * as React from 'react';
import { DEFAULT_SETTINGS, LEGEND_SETTINGS, RESPONSIVE_SETTINGS } from './constants';
import Utils from './utils/common';
import Styles from "./Charts.css";

var FunnelChart =
/** @class */
function (_super) {
  tslib_1.__extends(FunnelChart, _super);

  function FunnelChart() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.getOptions = function () {
      var _a = _this.props,
          responsive = _a.responsive,
          disableDownload = _a.disableDownload,
          timeRange = _a.timeRange,
          title = _a.title,
          legendEnabled = _a.legendEnabled,
          legendPosition = _a.legendPosition;
      var _b = _this.props.data,
          data = _b.data,
          meta = _b.meta;

      var options = tslib_1.__assign({}, DEFAULT_SETTINGS, {
        type: 'funnel',
        dataProvider: data
      }, FunnelChart.defaultMeta, meta); // ------------------------------
      // Legend
      // ------------------------------


      if (legendEnabled) {
        options.legend = tslib_1.__assign({}, LEGEND_SETTINGS, {
          enabled: legendPosition !== 'none',
          position: 'right'
        }, meta.legend || {});

        if (meta.legend) {
          options.legend.data = meta.legend;
        }
      } // ------------------------------
      // Responsive
      // ------------------------------


      if (responsive) {
        options.responsive = tslib_1.__assign({}, RESPONSIVE_SETTINGS, {
          enabled: true
        });
      } // ------------------------------
      // Export
      // ------------------------------


      if (!disableDownload) {
        options.export = Utils.getExportOptions(title, timeRange);
      }

      return options;
    };

    return _this;
  }

  FunnelChart.prototype.render = function () {
    var _a = this.props,
        height = _a.height,
        className = _a.className;

    var style = tslib_1.__assign({}, height ? {
      height: height
    } : {});

    var options = this.getOptions();
    return React.createElement("div", {
      className: cx(Styles.barChart, className)
    }, React.createElement(AmCharts.React, {
      style: style,
      options: options
    }));
  };

  FunnelChart.defaultMeta = {
    neckWidth: '40%',
    neckHeight: '30%',
    pullDistance: 0,
    legendPosition: 'right',
    labelText: '[[percents]]%',
    funnelAlpha: 0.9,
    startX: 0,
    startAlpha: 0,
    outlineThickness: 1
  };
  return FunnelChart;
}(React.PureComponent);

export default FunnelChart;